import { z } from 'zod';

export const AzureAdAppSchema = z.object({
  displayName: z.string(),
  id: z.string(),
  appId: z.string(),
  signInAudience: z.union([
    z.literal('AzureADMyOrg'),
    z.literal('AzureADMultipleOrgs'),
    z.literal('AzureADandPersonalMicrosoftAccount'),
    z.literal('PersonalMicrosoftAccount')]),
});

export type AzureAdApp = z.infer<typeof AzureAdAppSchema>;
